import api from './api';

const validationService = {
  getTaskValidators: async (projectId, taskId) => {
    try {
      const response = await api.get(`/projects/${projectId}/tasks/${taskId}/validators`);
      return response.data.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  assignValidator: async (projectId, taskId, { userId, validatorType }) => {
    try {
      const response = await api.post(`/projects/${projectId}/tasks/${taskId}/validators`, {
        userId,
        validatorType
      });
      return response.data.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  removeValidator: async (projectId, taskId, userId) => {
    try {
      const response = await api.delete(`/projects/${projectId}/tasks/${taskId}/validators/${userId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  submitValidation: async (projectId, taskId, { decision, comment }) => {
    try {
      const response = await api.post(`/projects/${projectId}/tasks/${taskId}/validate`, {
        decision,
        comment
      });
      return response.data.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getValidationStatus: async (projectId, taskId) => {
    try {
      const response = await api.get(`/projects/${projectId}/tasks/${taskId}/validation-status`);
      return response.data.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getValidationSummary: async (projectId) => {
    try {
      const response = await api.get(`/projects/${projectId}/validation-summary`);
      return response.data.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getValidationHistory: async (projectId, taskId) => {
    try {
      const response = await api.get(`/projects/${projectId}/tasks/${taskId}/validation-history`);
      return response.data.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export default validationService;
